import React from 'react';
import {Dropdown} from "react-bootstrap";
import styles from "./Dropdown.module.sass"

import {Row, Col, Button} from 'react-bootstrap'

export const DropdownList = () => {
    const scrollToElement = (id: string) => {
        const element = document.getElementById(id);
        element?.scrollIntoView({ behavior: 'smooth' });
    };
    return (
        <div className={styles.dropdown__wrap}>
            <Dropdown>
                <Dropdown.Toggle className={styles.toggle} id="dropdown-button-dark-example1" variant="secondary">
                    <div className={styles.dropdown__button}>
                        <div className={styles.dropdown__button__line}></div>
                        <div className={styles.dropdown__button__line}></div>
                        <div className={styles.dropdown__button__line}></div>
                    </div>
                </Dropdown.Toggle>

                <Dropdown.Menu className={styles.dropdown__menu} variant="dark">
                    <div onClick={() => scrollToElement('sectionOrder')} className={styles.dropdown__text}>
                        Оставить заявку <br/>
                    </div>
                    <Dropdown.Divider className={styles.dropdown__line}/>
                    <div onClick={() => scrollToElement('sectionMap')} className={styles.dropdown__text}>
                        Магазины <br/>
                    </div>
                    <div onClick={() => scrollToElement('sectionAbout')} className={styles.dropdown__text}>
                        Компания <br/>
                    </div>
                    <div onClick={() => scrollToElement('sectionCatalog')} className={styles.dropdown__text}>
                        Каталог <br/>
                    </div>
                    <div onClick={() => scrollToElement('sectionReview')} className={styles.dropdown__text}>
                        Отзывы <br/>
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};
